import {
  Box,
  Dialog,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CustomText from 'components/common/CustomText/CustomText';
import React from 'react';
import { colors } from 'styles/colors';

interface Props {
  open: boolean;
  title?: string;
  message?: string;
  content?: React.ReactNode;
  buttons?: any[];
  onClose?: () => void;
  alignText?: string;
  autoClose?: boolean;
  width?: number;
}

function CustomDialog({
  open,
  title,
  message,
  buttons = [],
  content,
  onClose,
  alignText = 'left',
  autoClose = false,
  width = 360,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={autoClose ? onClose : undefined}
      slotProps={{
        transition: { unmountOnExit: true },
        paper: {
          sx: {
            borderRadius: 2,
            boxShadow: 24,
            pt: 3,
            px: 3,
            pb: buttons.length > 0 ? 3 : 0,
            width: { xs: '90vw', sm: width, md: width*1.3 },
            maxWidth: '95vw',
            position: 'relative',
          },
        },
      }}
    >
      {/* Close button */}
      {onClose && (
        <IconButton
          onClick={onClose}
          disableRipple
          sx={{
            position: 'absolute',
            top: 15,
            right: 15,
            backgroundColor: colors.primary,
            height: 25,
            width: 25,
          }}
        >
          <CloseIcon sx={{ fontSize: 15, color: colors.white }} />
        </IconButton>
      )}

      {title && (
        <Box my={0.2}>
          <CustomText
            text={title}
            fontWeight={700}
            fontSize={20}
            textAlign={alignText as any}
          />
        </Box>
      )}

      {message && (
        <Box mt={1}>
          <CustomText 
          text={message} 
          fontSize={16} 
          textAlign={alignText as any} />
        </Box>
      )}

      {content && <Box>{content}</Box>}

      {buttons?.length > 0 && (
        <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
          {buttons.map((item) => item)}
        </Box>
      )}

    </Dialog>
  );
}

export default CustomDialog;
